const initialState = {
  participantDataSending: false,
  participantRegisterSuccess: false,
  sponsorDataSending: false,
  sponsorRegisterSuccess: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'PARTICIPANT_REGISTER_PENDING':
      return {
        ...state,
        participantDataSending: true,
        participantRegisterSuccess: false
      };
    case 'PARTICIPANT_REGISTER_DONE':
      return {
        ...state,
        participantDataSending: false,
        participantRegisterSuccess: true
      };
    case 'PARTICIPANT_REGISTER_ERROR':
      return {
        ...state,
        participantDataSending: false,
        participantRegisterSuccess: false
      };
    case 'SPONSOR_REGISTER_PENDING':
      return {
        ...state,
        sponsorDataSending: true,
        sponsorRegisterSuccess: false
      };
    case 'SPONSOR_REGISTER_DONE':
      return {
        ...state,
        sponsorDataSending: false,
        sponsorRegisterSuccess: true
      };
    case 'SPONSOR_REGISTER_ERROR':
      return {
        ...state,
        sponsorDataSending: false,
        sponsorRegisterSuccess: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/google-form-reducer.js